// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1bLqt","ranges":"BmiRanges_ranges__3_9lT"};